// extracted by mini-css-extract-plugin
export default {"container":"ComparisonTable_container__OPJyo"};